/**
 * One outline thickness for every button (Gordon 2026-11-01: "same thickness
 * outline on buttons and customize them in setting. use search button outline
 * thickness as default"). globals.css turns two CSS-variable layers on <html>
 * into --btn-outline-border-width, which every outlined button, tab and edge
 * button reads:
 *   --bb-btn-outline-v  BB's default — Super Admin → Global Appearance
 *   --bb-btn-outline-u  a signed-in person's own choice (Settings → Layout)
 * The person's layer only counts while html[data-signed-in="1"]; without
 * either, it's 1px (Gordon 2026-11-02: "thinner outlines on all buttons for
 * the system default, more delicate"; it was 2px, the search button's).
 */

export const BUTTON_OUTLINE_DEFAULT = '1px';
export const BUTTON_OUTLINE_WIDTHS = ['1px', '1.5px', '2px', '3px', '4px'] as const;

/** Device copy of the person's choice, replayed before first paint (layout.tsx). */
export const LS_BUTTON_OUTLINE = 'bb-btn-outline';

/** A width from the list above, or null. */
export function cleanOutlineWidth(v: unknown): string | null {
  return typeof v === 'string' && (BUTTON_OUTLINE_WIDTHS as readonly string[]).includes(v) ? v : null;
}

export function applyButtonOutline(scope: 'visitor' | 'user', width: string | null | undefined): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const prop = scope === 'visitor' ? '--bb-btn-outline-v' : '--bb-btn-outline-u';
  const w = cleanOutlineWidth(width);
  if (w) root.style.setProperty(prop, w);
  else root.style.removeProperty(prop);
  if (scope !== 'user') return;
  try {
    if (w) localStorage.setItem(LS_BUTTON_OUTLINE, w);
    else localStorage.removeItem(LS_BUTTON_OUTLINE);
  } catch { /* private mode */ }
}

/** The width BB gives everyone who hasn't picked one. */
export function defaultButtonOutline(): string {
  if (typeof document === 'undefined') return BUTTON_OUTLINE_DEFAULT;
  return cleanOutlineWidth(document.documentElement.style.getPropertyValue('--bb-btn-outline-v').trim()) || BUTTON_OUTLINE_DEFAULT;
}
